'use strict';

import controller from './orden-proceder.controller';
import template from './orden-proceder.html';

const OrdenProcederComponent = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default OrdenProcederComponent;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/orden-proceder/orden-proceder.component.js